export default "__VITE_ASSET__BHkc7qYH__"